import { Autoplay, EffectFade } from "swiper/modules";
import { CustomSwiper } from "../swiper/custom-swiper.js";

export class Hero {
	public constructor(el: HTMLElement) {
		// track if the video/swiper was paused manually by the user
		let manualPause = false;

		// identify elements
		const elSwiper = el.querySelector(".swiper");
		const elVideo = el.querySelector("video");
		const elPause = el.querySelector(".hero__pause");

		// create swiper instances
		const heroSwiper = this.#getHeroImageSwiper(elSwiper);
//		if (heroSwiper) {
//			elPause?.setAttribute("aria-hidden", "false");
//		}

		// bind actions to video player
		if (elVideo instanceof HTMLVideoElement) {
//			elPause?.setAttribute("aria-hidden", "false");
			// manage video playback
			// - only autoplay/load video when video is visible
			// - pause/resume video as it goes out of / in to view
			new IntersectionObserver(entries => {
				if (!entries[0]?.isIntersecting) {
					elVideo.pause();
					return;
				}

				if (!manualPause) {
					!elVideo.autoplay && (elVideo.autoplay = true);
					elVideo.play();
				}
			}).observe(elVideo);
		}

		// bind actions to pause button
		if (elPause instanceof HTMLElement) {
			const btnTitlePaused = elPause.dataset["titlePaused"] ?? "";
			const btnTitlePlaying = elPause.dataset["titlePlaying"] ?? "";

			elPause.setAttribute("aria-label", btnTitlePlaying);
			elPause.setAttribute("title", btnTitlePlaying);

			elPause.addEventListener("click", () => {
				const isPausePressed = !(elPause.getAttribute("aria-pressed") === "true");
				manualPause = isPausePressed;

				// update the 'pressed' state of the pause button
				elPause.setAttribute("aria-pressed", String(isPausePressed));
				const btnTitle = isPausePressed ? btnTitlePaused : btnTitlePlaying;
				elPause.setAttribute("aria-label", btnTitle);
				elPause.setAttribute("title", btnTitle);

				// toggle hero swiper play/pause state
				if (heroSwiper) {
					isPausePressed ? heroSwiper.autoplay.pause() : heroSwiper.autoplay.resume();
				}

				// toggle hero video play/pause state
				if (elVideo) {
					isPausePressed ? elVideo.pause() : elVideo.play();
				}
			});
		}
	}

	/**
	 *
	 */
	#getHeroImageSwiper(elSwiper: Element | null): CustomSwiper | undefined {
		let heroSwiper: CustomSwiper | undefined;
		if (elSwiper instanceof HTMLElement) {
			const elSlides = elSwiper.querySelectorAll(".swiper-slide");
			// if there's only 1 slide, nothing to slide between
			if (elSlides.length > 1) {
				heroSwiper = new CustomSwiper(elSwiper, {
					modules: [
						Autoplay,
						EffectFade
					],
					spaceBetween: 0,
					allowTouchMove: false,
					autoplay: {
						delay: 3000,
						disableOnInteraction: false
					},
					effect: "fade",
					speed: 1000
				});
			}
		}

		return heroSwiper;
	}
}
